import {
  Image,
  NativeSyntheticEvent,
  Platform,
  Pressable,
  PressableProps,
  StyleProp,
  StyleSheet,
  TargetedEvent,
  View,
  ViewStyle,
} from 'react-native'
import { Comment, Photo } from 'zens-store'
import { Color, Radius, Spacing, Text } from 'zens-storybook'
import { useEffect, useState } from 'react'

import Placeholder from '@dms/../assets/images/placeholder.png'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: Spacing.L,
    paddingVertical: Spacing.S,
  },
  date: {
    color: Color.metalGrey,
    marginBottom: Spacing.S,
  },
  commentPressed: {
    color: Color.premiumBlack,
  },
  commentActive: {
    color: Color.greyBlue,
  },
  photo: {
    width: 95,
    height: 75,
    borderColor: Color.calmGrey,
    borderWidth: 1,
    borderRadius: Radius.S,
    padding: Spacing.XS,
  },
  photoPressed: {
    borderColor: Color.premiumBlack,
  },
  photoActive: {
    borderColor: Color.greyBlue,
  },
  image: {
    width: '100%',
    height: '100%',
  },
})

interface Props extends Omit<PressableProps, 'style'> {
  data: Comment | Photo
  showAll?: boolean
  style?: StyleProp<ViewStyle>
}

const FeedbackRow = (props: Props) => {
  const { data, showAll, disabled, onFocus, onBlur, style, ...otherProps } = props
  const { displayCreatedAt } = data
  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => (event: NativeSyntheticEvent<TargetedEvent>) => {
    setActive(value)
    value && onFocus && onFocus(event)
    !value && onBlur && onBlur(event)
  }
  useEffect(() => {
    if (disabled) setActive(false)
  }, [disabled])

  function renderComment(comment: Comment, state: { pressed: boolean; hovered?: boolean }) {
    const { hovered } = state
    const commentStyle = [hovered && styles.commentPressed, active && styles.commentActive]

    return (
      <View>
        <Text style={commentStyle} numberOfLines={showAll ? 0 : 3}>
          {comment.text}
        </Text>
      </View>
    )
  }

  function renderPhoto(comment: Photo, state: { pressed: boolean; hovered?: boolean }) {
    const { hovered } = state
    const photoStyle = [styles.photo, hovered && styles.photoPressed, active && styles.photoActive]
    return (
      <View style={photoStyle}>
        <Image source={{ uri: comment.url }} defaultSource={Placeholder} style={styles.image} />
      </View>
    )
  }

  function renderRow(state: { pressed: boolean; hovered?: boolean }) {
    return (
      <>
        <Text style={styles.date}>{displayCreatedAt}</Text>
        {data instanceof Comment ? renderComment(data, state) : renderPhoto(data, state)}
      </>
    )
  }

  return (
    <Pressable
      disabled={disabled}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      style={[
        styles.container,
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        style,
      ]}
      testID="FeedbackRow.Container"
      {...otherProps}
    >
      {renderRow}
    </Pressable>
  )
}

export default FeedbackRow
